import { useContext } from "react";
import { CheckoutContext } from "contexts/CheckoutProvider";
import { submitFormik } from "utils/forms";
import { FormikSubmitStep } from "components/Step/stepTypes";
import {
  PlanPrepaidSlug,
  SelectPlanKey,
  SelectPlanSubmit,
  SelectPlanValues,
  SubscriptionPlanSlug,
} from "components/PlanSelection/planSelectionTypes";

export const schoolboxPrepaidCoupons = [
  "1DOLLARBOX-3BOXES",
  "1DOLLARBOX-6BOXES",
  "1DOLLARBOX-12BOXES",
];

export const SchoolBoxPrepaidCouponCode: Record<
  PlanPrepaidSlug,
  string | null
> = {
  "prepaid-monthly": null,
  "prepaid-3-month-0224": "1DOLLARBOX-3BOXES",
  "prepaid-6-month-0224": "1DOLLARBOX-6BOXES",
  "prepaid-12-month-0224": "1DOLLARBOX-12BOXES",
} as const;

export interface UseSelectPlanArgs {
  onSubmit?: FormikSubmitStep<SelectPlanValues>;
}

export function useSelectPlan({ onSubmit }: UseSelectPlanArgs) {
  const { updateSelectedPlan } = useContext(CheckoutContext);

  const handleSubmit: SelectPlanSubmit = async (values, formikHelpers) => {
    return await submitFormik({
      onSubmit: async () => {
        await updateSelectedPlan?.({
          plan: values[SelectPlanKey.PLAN_SLUG] as SubscriptionPlanSlug,
        });
      },
      onSuccess: async () => onSubmit?.(values, formikHelpers),
      formikProps: formikHelpers,
    });
  };

  return {
    handleSubmit,
  };
}
